import { SnackbarProvider } from 'notistack';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import RoutesConfig from './RoutesConfig';
import './styles/common.scss';

const theme = createTheme({
  palette: {
    primary: {
      main: '#AE2828',
    },
  },
  typography: {
    fontFamily: "'Manrope', sans-serif",
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        autoHideDuration={5000}
        anchorOrigin={{ vertical : 'top', horizontal : 'right' }}
        maxSnack={1}
      >
        <RoutesConfig />
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
